import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { approveMultipleWithComment, getQuotaForApproval, setState, Upload } from "./quotaModificationSlice";
import { Button, TextField, Typography } from "@mui/material";

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
   borderRadius: 1,
};

export default function ApproveWithCommentModal() {
   const dispatch = useDispatch();
   const {
      appWithCommentModal,
      appMulWithComment,
      selectedCountryID,
      selectedPeriod,
      selectedQuotaStatus,
      searchText,
      quotaList,
      selectedQuotaid,
      isButtonClicked,
      selectedRowsselected
   } = useSelector((store) => store.quotaModification);

   function handleClose() {
      dispatch(setState("appWithCommentModal", false));
      dispatch(setState("isButtonClicked", false));
      dispatch(setState("appMulWithComment",""));
      dispatch(setState("selectedQuotaid",null));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("appMulWithComment", comment));
   }

   function search() {
	   dispatch(setState("rejectSelectedComment",''));
      dispatch(setState("appMulWithComment",""));
      dispatch(setState("selectedQuotaid",null));
      dispatch(setState("scenarioModificationList",null));
      dispatch(setState("expandedRowIndex",null));
      dispatch(setState("selectedRowsselected", []));
      const logedUser = JSON.parse(localStorage.getItem("data"));
      const countryId = selectedCountryID;
      const period = selectedPeriod;
      const quotaStatus = selectedQuotaStatus;

      const obj = {
         countryId,
         period,
         quotaStatus,
         logedUser,
         searchText: searchText,
      };
      dispatch(getQuotaForApproval(obj));
   }

   function approveSelected() {

      const user = JSON.parse(localStorage.getItem("data"));
      let qList = [];
      if(!isButtonClicked){
      let quota= quotaList.find((item) => item.quotaId === selectedQuotaid);
         quota = {
            ...quota,
            approveComments: appMulWithComment,
         }
         const obj = {
            ...quota,
            user,
         };
         qList.push(obj);
      }
      else{
         for (let i = 0; i < selectedRowsselected.length; ++i) {
            let quota = quotaList.find((item) => item.quotaId === selectedRowsselected[i].quotaId);
            quota = {
               ...quota,
               approveComments: appMulWithComment,
            }
            console.log(quota);
            const obj = {
               ...quota,
               user,
            };
            qList.push(obj);
         }
      }
      console.log("Approve_Quota_ApproveSelectedWithComment", qList);
      dispatch(approveMultipleWithComment(qList)).then(() =>
      {
         search(); 
      });
      handleClose();
   }

   return (
      <Box>
         <Modal open={appWithCommentModal} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField
                  className={'fullWidth'}
                  size="large"
                  multiline
                  rows={6}
                  style={{overflowY:'auto'}}
                  value={appMulWithComment}
                  onChange={setComment}
               />
               <br />
               <Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<Button
							sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								mr: 2,
								"&:hover": {
									bgcolor: "darkred.main",
									color: "white.main",
								},
							}}
							onClick={handleClose}
						>
							Close
						</Button>

						<Button
							sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								"&:hover": {
									bgcolor: "darkred.main",
									color: "white.main",
								},
							}}
							onClick={approveSelected}
						>
							Approve
						</Button>
					</Box>
            </Box>
         </Modal>
      </Box>
   );
}
